export const AddressInfo = () => (
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d172.9792336731353!2d10.348559571828297!3d46.077665953464894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4783b54890cf53c1%3A0xf297a377a4704688!2sForesteria%20Antica%20Farmacia!5e0!3m2!1sit!2sit!4v1657401300807!5m2!1sit!2sit"
    width="100%"
    height="450"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="map"
  />
)
